import React from 'react';
import ButtonLoader from '../ButtonLoader';
import styles from '../../styles/LoadingScreen.module.scss';

const LoadingScreen = () => {
  return (
    <div className={styles.container}>
      <ButtonLoader dark />
    </div>
  );
};

export default LoadingScreen;
